// EyeClosedSvg.js
export const EyeClosedSvg = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4c-5 0-9 3.5-11 7.5 1.3 2.5 3.5 5.2 6.4 6.5m10.3-2.1A11 11 0 0023 11.5c-2-4-6-7.5-11-7.5-1.8 0-3.6.5-5.2 1.3M10 10a2 2 0 012-2 2 2 0 012 2m0 4a2 2 0 01-2-2m-6.7 8L21 3"
        stroke="#FFF"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
  